import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const NumberInputValue = ({ rule, onValueChange, disabled }) => (
  <Input
    type='number'
    value={rule.numberValue}
    onChange={(e, data) => onValueChange(rule.instanceId, 'numberValue', data.value)}
    disabled={disabled}
    input={{ 'data-testid': `number-input-${rule.id}` }}
  />
);

NumberInputValue.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default NumberInputValue;
